import React from "react";
import { useTranslation } from "react-i18next";

import { useMarkMilestoneAsCompleted } from "@planzone/view-models";
import { Modal } from "@common/modal";
import { Button } from "@common/button";
import { Props } from "./types";
import { Form } from "./form";
import styles from "./styles.scss";

function MilestoneCompletion({ cancel, milestone }: Props) {
  const { t } = useTranslation();
  const now = new Date();
  const [completionDate, setCompletionDate] = React.useState(
    new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      0,
      0,
      0,
    ).toISOString(),
  );
  const { isRequestPending, markMilestoneAsCompleted } =
    useMarkMilestoneAsCompleted(milestone);

  return (
    <Modal
      header={t("milestoneCompletion.title")}
      headerClassName={styles.header}
      close={cancel}
    >
      <div className={styles.main}>
        <h3 className={styles.title}>{t("milestoneCompletion.subTitle")}</h3>
        <div className={styles.form}>
          <Form
            date={completionDate}
            milestoneEndDate={milestone.endDate}
            editDate={setCompletionDate}
          />
        </div>
        <div className={styles.buttons}>
          <Button type="cancel" press={cancel}>
            {t("milestoneCompletion.cancel")}
          </Button>
          <Button
            className={styles.confirmButton}
            status={isRequestPending ? "pending" : "none"}
            press={() => {
              const rounded = new Date(completionDate);

              markMilestoneAsCompleted({
                milestone,
                completionDate: new Date(
                  rounded.getFullYear(),
                  rounded.getMonth(),
                  rounded.getDate(),
                  0,
                  0,
                  0,
                ).toISOString(),
              });
            }}
          >
            {t("milestoneCompletion.submit")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export { MilestoneCompletion };
